import produce from 'immer';
import {
    GET_ROAMING_OPTIONS_FAILED,
    GET_ROAMING_OPTIONS_SUCCESS,
    SET_COUNTRY,
    SET_DEFAULT_STATE,
    SET_DEFAULT_STATE_FAILED,
    SET_DEFAULT_STATE_SUCCESS,
    SET_DESTINATION,
    SET_TARIFF,
    RoamingRestriction,
    Destination,
} from './constants';
import {
    Country,
    RaError,
} from './types';
import { checkIfRoamingIsNotAllowed } from './utils/utils';
import { getRaLocale } from './utils/getLocale';

/**
 * Basket Interface
 */
export interface IRoamingAdvisorState {
    /**
     * loading
     */
    loading: boolean;
    /**
     * error
     */
    error: boolean | RaError;
    /**
     * countries
     */
    countries: boolean | Array<Country>;
    /**
     * selectedDestination
     */
    selectedDestination: boolean | Destination;
    /**
     * selectedDestination
     */
    selectedCountry: boolean | string;
    /**
     * selectedDestination
     */
    selectedTariff: boolean | string;
    /**
     * roamingOptions
     */
    roamingOptions: boolean | [object];
    /**
     * noRoamingForSelectedCountry
     */
     noRoamingForSelectedCountry: boolean | RoamingRestriction;

}

/**
 * Export initalState
 */
export const initialState: IRoamingAdvisorState = {
    loading: false,
    error: false,
    countries: false,
    noRoamingForSelectedCountry: false,
    selectedDestination: false,
    selectedCountry: false,
    selectedTariff: false,
    roamingOptions: false,
};

const roamingAdvisorReducer = (state: IRoamingAdvisorState = initialState, action) =>
    produce(state, (draft: IRoamingAdvisorState) => {
        switch (action.type) {
            case SET_DEFAULT_STATE:
                draft.loading = true;
                break;

            case SET_DEFAULT_STATE_SUCCESS:
                draft.loading = false;
                draft.countries = action.countries;
                draft.error = false;
                break;

            case SET_DEFAULT_STATE_FAILED:
                draft.loading = false;
                draft.countries = false;
                draft.error = {
                    seriousError: true,
                    headline: getRaLocale('headlineCountriesServerError'),
                    content: getRaLocale('textCountriesServerError'),
                };
                break;

            case SET_DESTINATION:

                draft.selectedDestination = action.destination;
                draft.selectedCountry = false;
                draft.selectedTariff = false;
                draft.roamingOptions = false;
                draft.error = false;

                break;

            case SET_COUNTRY:
                // eslint-disable-next-line no-case-declarations
                const checkIfRoamingIsNotAllowedFlag
                    = checkIfRoamingIsNotAllowed(state.countries, action.country, state.selectedDestination);

                if (!checkIfRoamingIsNotAllowedFlag) {
                    draft.selectedCountry = action.country;
                    draft.selectedTariff = false;
                    draft.roamingOptions = false;
                    draft.noRoamingForSelectedCountry = false;
                    draft.error = false;
                }
                else {
                    draft.selectedCountry = action.country;
                    draft.selectedTariff = false;
                    draft.roamingOptions = false;
                    draft.noRoamingForSelectedCountry = checkIfRoamingIsNotAllowedFlag;

                    if (checkIfRoamingIsNotAllowedFlag === RoamingRestriction.notInForeignCountry) {
                        draft.error = {
                            seriousError: false,
                            headline: getRaLocale('headlineNoRoamingInForeignCountryNotification'),
                            content: getRaLocale('textNoRoamingInForeignCountryNotification'),
                        };
                    }
                    else {
                        draft.error = {
                            seriousError: false,
                            headline: getRaLocale('headlineNoRoamingToForeignCountryNotification'),
                            content: getRaLocale('textNoRoamingToForeignCountryNotification'),
                        };
                    }
                }

                break;

            case SET_TARIFF:
                draft.selectedTariff = action.tariff;
                draft.loading = true;
                draft.error = false;
                draft.roamingOptions = false;
                break;

            case GET_ROAMING_OPTIONS_SUCCESS:
                draft.loading = false;
                draft.roamingOptions = action.options;

                break;

            case GET_ROAMING_OPTIONS_FAILED:
                draft.error = {
                    seriousError: true,
                    headline: getRaLocale('headlineTariffsServerError'),
                    content: getRaLocale('textTariffsServerError'),
                };
                draft.loading = false;
                break;
        }
    });

export default roamingAdvisorReducer;
